// 录入时间，推广方式，信息分级，信息类型，信息状态，信息来源，录入人员，审核人员，跟进人员，所属团队/小组
// 信息标题，需求信息，需求说明
// 公司名称，联系人，手机号码，邮箱，公司地址
// 成交时间，合同编号，成交金额
import { getQuery, setQuery } from '@/services/inqueryServices'
const state = {
  loading: true,
  filterAllData: {},
  filterFormData: [],
  filterResult: {},
  filterStr: '',
  filterSort: []
}

const getters = {
  filterForm (state) {
    // 移动端用
    let data = { ...state.filterFormData }
    for (let k in data) {
      let item = data[k]
      item.props = {}
      if (item.child) {
        item.props.options = item.child
        for (let i in item.props.options) {
          let option = item.props.options[i]
          option.label = option.fieldname
          option.value = option.fieldkey
        }
      }
    }
    return data
  }
}
const mutations = {
  GET_QUERY (state, data = {}) {
    const { allconfig = {}, config = {} } = data
    // 过滤原始数据
    for (let k in allconfig) {
      if (allconfig[k].child.length === 0) {
        delete allconfig[k]
      }
    }
    state.filterAllData = allconfig
    state.filterFormData = config
    state.filterSort = config
  },
  SET_LOADING (state, data) {
    state.loading = data
  },
  SET_FILTER_RESULT (state, data) {
    state.filterResult = data
  },
  SET_FILTER_STR (state, data) {
    state.filterStr = data
  },
  SET_FILTER_SORT (state, data) {
    state.filterSort = data
  }
}
const actions = {
  async fetchQuery ({ commit }) {
    commit('SET_LOADING', true)
    const chain = await getQuery()
      .onSuccess(async payload => {
        commit('GET_QUERY', payload)
        commit('SET_LOADING', false)
      })
      .onFail(_ => {
        commit('SET_LOADING', false)
      })
    return chain
  },

  async setQuery ({ commit }) {
    const chain = await setQuery().onSuccess(async payload => {
      // console.log(payload)
    })
    return chain
  },
  setFilterResult ({ commit }, data) {
    commit('SET_FILTER_RESULT', data)
  },
  setFilterStr ({ commit }, data) {
    commit('SET_FILTER_STR', data)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}

// 筛选表单数据格式如下
/* $search = [
  'input_time'                => [
      'starttime' => '2019-01-01',
      'endtime'   => '2019-10-01',
  ],
  'input_userid'              => [
      [
          'roleid'  => 74,
          'groupid' => 470,
          'userid'  => 649,
      ],
      [
          'roleid'  => 76,
          'groupid' => 438,
      ],
  ],
  'audit_userid'              => [
      [
          'roleid'  => 1,
          'groupid' => 2,
          'userid'  => 3,
      ],
      [
          'roleid'  => 11,
          'groupid' => 22,
      ],
  ],
  'follow_userid'             => [
      'follow_status' => [1, 2],
      'follow_userid' => [
          [
              'roleid'  => 1,
              'groupid' => 2,
              'userid'  => 3,
          ],
          [
              'roleid'  => 11,
              'groupid' => 22,
              'userid'  => 33,
          ],
      ],
  ],
  'dev_roleid_groupid'        => [
      [
          'roleid'  => 1,
          'groupid' => 2,
      ],
      [
          'roleid'  => 11,
          'groupid' => 22,
      ],
  ],
  'base_info.info_plan'       => [17, 2],
  'contact_info.company_name' => '公司',

  "from_info": =>  [
    {"from_info.from_search_engine":1},
    {"from_info.from_search_engine":2},
    ("from_info.email_from_detail": 18}
  ]

  'address' => []
]; */
